module.exports = "img/flags/ET.d8eeaef.png";